import React, { useContext, useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { addContactDetails, addOnView } from "../../Redux/Actions/CardAction";
// import { CardContext } from "../../store/CardContext";


const Forms = () => {
  // const dispatch = useDispatch();
  // const { contactDetails } = useSelector((state) => state.cardReducer);

  // const initialValues = {
  //   address: contactDetails?.address,
  //   state: contactDetails?.state,
  //   country: contactDetails?.country,
  //   googleMapUrl: contactDetails?.googleMapUrl,
  // };

  const [contactDetail, setContactDetail] = useState('')
  // const [userContextData, setUserContextData] = useContext(CardContext)

  // useEffect(() => {
  //   setContactDetail({
  //     address: userContextData?.address,
  //     state: userContextData?.state,
  //     country: userContextData?.country,
  //     locationUrl: userContextData?.locationUrl,
  //   })
  // }, [userContextData])

  const urlRegex = /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactDetail({ ...contactDetail, [name]: value });
  };

  // useEffect(() => {
  //   dispatch(addContactDetails(contactDetail));
  //   dispatch(addOnView("contactDetail"));
  // }, [contactDetail]);

  return (
    <div className="grid gap-6 mb-6 md:grid-cols-2">
      <div>
        <label
          for="first_name"
          className="block mb-2 text-sm font-medium text-gray-900 "
        >
          Address
        </label>
        <input
          type="text"
          name="address"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          placeholder=""
          onChange={handleChange}
          value={contactDetail["address"] || ""}
          // value={contactDetails?.address || ""}
        />
        {/* {contactDetail?.address ||!validationCheck? (
          ""
        ) : (
          <p className="text-red-500">address is required</p>
        )} */}
      </div>
      <div>
        <label
          for="first_name"
          className="block mb-2 text-sm font-medium text-gray-900 "
        >
          State
        </label>
        <input
          type="text"
          name="state"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          placeholder=""
          onChange={handleChange}
          value={contactDetail["state"] || ""}
          // value={contactDetails?.state || ""}
        />
        {/* {contactDetail?.state ||!validationCheck? (
          ""
        ) : (
          <p className="text-red-500">state is required</p>
        )} */}
      </div>
      <div>
        <label
          for="first_name"
          className="block mb-2 text-sm font-medium text-gray-900 "
        >
         Headquarters Address
        </label>
        <input
          type="text"
          name="address"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          placeholder=""
          onChange={handleChange}
          value={contactDetail["address"] || ""}
          // value={contactDetails?.address || ""}
        />
        {/* {contactDetail?.address ||!validationCheck? (
          ""
        ) : (
          <p className="text-red-500">address is required</p>
        )} */}
      </div>
      <div>
        <label
          for="first_name"
          className="block mb-2 text-sm font-medium text-gray-900 "
        >
          State
        </label>
        <input
          type="text"
          name="state"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          placeholder=""
          onChange={handleChange}
          value={contactDetail["state"] || ""}
          // value={contactDetails?.state || ""}
        />
        {/* {contactDetail?.state ||!validationCheck? (
          ""
        ) : (
          <p className="text-red-500">state is required</p>
        )} */}
      </div>


      {/* <div>
        <label
          for="first_name"
          className="block mb-2 text-sm font-medium text-gray-900 "
        >
          Country
        </label>
        <input
          type="text"
          name="country"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          placeholder=""
          onChange={handleChange}
          value={contactDetail["country"] || ""}
        />
        
      </div> */}



      {/* <div>
        <label
          for="first_name"
          className="block mb-2 text-sm font-medium text-gray-900 "
        >
          Google Map Url
        </label>
        <input
          type="text"
          name="locationUrl"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
          placeholder=""
          onChange={handleChange}
          value={contactDetail["locationUrl"] || ""}
          // value={contactDetails?.googleMapUrl || ""}
        />
        {contactDetail?.locationUrl ? (
          contactDetail?.locationUrl ? (urlRegex.test(contactDetail.locationUrl) ? (

            ""
          ) : (
            <p className="text-red-500">Enter Valid URL</p>
          ))
            : ''
        ) : (
          ""
        )}
      </div> */}
    </div>
  );
};

export default Forms;
